"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Container.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, collapsed = _a.collapsed, collapsedSmall = _a.collapsedSmall, tag = _a.tag, width = _a.width;
        var padding = collapsed || width == "full" ? "" : "";
        var maxWidth = width ? "max-w-" + width : "max-w-xl";
        return tag == "section" ? (React.createElement("section", { className: (className || "") + " w-full " + maxWidth + " mx-auto" + padding + " bg-cover bg-center bg-no-repeat", style: this.props.bgImage ? { backgroundImage: "url(\"" + this.props.bgImage + "\")" } : null }, children)) : (React.createElement("div", { className: "w-full " + maxWidth + " mx-auto " + padding + " " + (className ? " " + className : "") }, children));
    };
    return Container;
}(React.PureComponent));
exports.Container = Container;
